<template>
  <section class="f-74">
    <div class="alive_content">
      <div class="title f-center-title">三方应用生态覆盖更广泛</div>
      <div class="content">
        <div class="border_container_light video_size f-select-center" v-ia>
          <m-video
            ref="video"
            disablepictureinpicture
            playsinline
            webkit-playsinline
            src="@/v2/auto/assets/video/74/0.mp4"
            muted
          />
        </div>
        <div class="des f-center-sub-title">
          浏览器升级，支持创建 web 轻应用，快捷访问高频网站 <sup>[8]</sup>
        </div>
        <replay class="replay" @click="replayVideo($refs.video)" />
      </div>
    </div>
  </section>
</template>

<script>
import { videoPlayByVisibleArea, replayVideo } from '@/utils'
import replay from '@/components/replay.vue'

export default {
  name: 'Assistant',
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    videoPlayByVisibleArea(this.$refs.video)
  },
  methods: {
    replayVideo,
  },
}
</script>

<style lang="less" scoped>
.f-74 {
  width: 100%;
  height: 1245px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(173.42deg, #d5e0f2 7.71%, #ffffff 80.08%);
  .alive_content {
    width: 100%;
    margin-top: 190px;
    margin-bottom: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title {
      margin-bottom: 50px;
      font-weight: 700;
      display: flex;
      background: radial-gradient(
          146.28% 782.22% at 12.95% -74.31%,
          #0061d8 0%,
          #00d369 100%
        )
        /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
      background-clip: text;
      color: transparent;
      .title_bold {
        font-weight: 700;
      }
    }
    .content {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .video_size {
        overflow: hidden;
        video {
          width: 100%;
          height: 100%;
          border-radius: 16px;
          object-fit: cover;
          object-position: center;
        }
      }

      .replay {
        margin-top: 20px;
        color: #3b82fc;
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 1;
      }
      .des {
        position: relative;
        display: flex;
        margin-top: 30px;
        width: 100%;
        justify-content: center;
        color: #00000080;
        sup {
          font-size: 12px;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
